import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.css'

import axios from 'axios'

// ====== 版本号 ======
const APP_VERSION = process.env.VUE_APP_VERSION || 'dev'

// ✅ 开发环境直接启动，不做版本检测
if (process.env.NODE_ENV !== 'production') {
  initApp()
} else {
  checkVersion()
}

// ====== 版本检测 ======
function checkVersion() {
  fetch('/version.json', {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-cache' }
  })
    .then(res => {
      if (!res.ok) return initApp()
      return res.json()
    })
    .then(data => {
      if (data && data.version && data.version !== APP_VERSION) {
        if (!sessionStorage.getItem('__reloaded__')) {
          sessionStorage.setItem('__reloaded__', '1')
          window.location.reload()
        } else {
          initApp()
        }
        return
      }
      initApp()
    })
    .catch(() => {
      // ✅ 关键：出错也要启动应用
      initApp()
    })
}

// ====== Vue 初始化 ======
function initApp() {
  Vue.prototype.$getTime = function () {
    const d = new Date()
    const pad = n => n.toString().padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  }

  Vue.prototype.$http = axios
  Vue.use(ElementUI)

  Vue.directive('focus', {
    inserted(el) {
      el.querySelector('input')?.focus()
    }
  })

  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  sessionStorage.removeItem('__reloaded__')
}